import HeaderSection from '../home/HeaderSection';
import FooterSection from '../home/FooterSection';
import RichContent from './RichContent';

function ContentPageLayout({ title, content, loading, error }) {
  return (
    <>
      <HeaderSection />

      <main className="mx-auto min-h-[80vh] max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-14">
        <h1 className="text-2xl font-bold text-[#146599] sm:text-3xl">{title}</h1>

        {loading ? (
          <div className="mt-8 space-y-4">
            <div className="h-4 w-full animate-pulse rounded bg-gray-100" />
            <div className="h-4 w-11/12 animate-pulse rounded bg-gray-100" />
            <div className="h-4 w-10/12 animate-pulse rounded bg-gray-100" />
            <div className="h-4 w-full animate-pulse rounded bg-gray-100" />
          </div>
        ) : error ? (
          <p className="mt-8 text-center text-base text-red-600">{error}</p>
        ) : (
          <div className="mt-8">
            <RichContent content={content} />
          </div>
        )}
      </main>

      <FooterSection />
    </>
  );
}

export default ContentPageLayout;
